



$(".atcax-button").on("click", function() {
  $(".subscription-step").removeClass("active");
  $(".subscription-step").css("display", "none");
  $(".final-ssteppx").addClass("active");
  $(".final-ssteppx").css({ 'display': 'flex', 'left': '0%', 'opacity': '1', 'position': 'relative' })
})

$(".atcmmcx-button").on("click", function() {
  $(".subscription-step").removeClass("active");
  $(".subscription-step").css("display", "none");
  $(".final-steppx").addClass("active");
  $(".final-steppx").css({ 'display': 'flex', 'left': '0%', 'opacity': '1', 'position': 'relative' })
})


$(".atcx-button").on("click", function() {
  $(".subscription-step").removeClass("active");
  $(".subscription-step").css("display", "none");
  $(".final-ssteppx").addClass("active");
  $(".final-ssteppx").css({ 'display': 'flex', 'left': '0%', 'opacity': '1', 'position': 'relative' })
})

$(".atcmmx-button").on("click", function() {
  $(".subscription-step").removeClass("active");
  $(".subscription-step").css("display", "none");
  $(".final-steppx").addClass("active");
  $(".final-steppx").css({ 'display': 'flex', 'left': '0%', 'opacity': '1', 'position': 'relative' })
})


// Activarte next buttons section

document.addEventListener('DOMContentLoaded', function() {
    // Get references to the input fields for cat and dog names
    const catNameInput = document.getElementById('catNameInput-0');
    const dogNameInput = document.getElementById('dogNameInput-0');

    // Get references to the content sections (for cat and dog)
    const gatoContent = document.getElementById('gatoContent0001');
    const perroContent = document.getElementById('perroContent0001');

    // Get references to the "Siguiente" button's wrapper and the button itself
    const nextButtonWrapper = document.querySelector('.dog-name.next');
    const nextButton = nextButtonWrapper.querySelector('button');

    /**
     * Updates the disabled state of the "Siguiente" button for Section 1.
     * The button is enabled if the currently visible name input field has text.
     */
    function updateSection1NextButtonState() {
      let currentInput;

      // Determine which input field is currently active (visible)
      if (!gatoContent.classList.contains('hidden0001')) {
        currentInput = catNameInput; // Cat content is visible
      } else if (!perroContent.classList.contains('hidden0001')) {
        currentInput = dogNameInput; // Dog content is visible
      } else {
        currentInput = null; // Neither content is visible, or an unexpected state
      }

      // Check if there's a relevant input and if it contains any non-whitespace text
      if (currentInput && currentInput.value.trim() !== '') {
        // If text is present, enable the button
        nextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        nextButton.removeAttribute('disabled');
      } else {
        // If the input is empty, disable the button
        nextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        nextButton.setAttribute('disabled', '');
      }
    }

    // Add event listeners:
    // 1. When text is typed into the cat name input
    catNameInput.addEventListener('input', updateSection1NextButtonState);
    // 2. When text is typed into the dog name input
    dogNameInput.addEventListener('input', updateSection1NextButtonState);
    // 3. When the "GATO" button is clicked (to update based on cat name input)
    document.getElementById('gatoButton0001').addEventListener('click', updateSection1NextButtonState);
    // 4. When the "PERRO" button is clicked (to update based on dog name input)
    document.getElementById('perroButton0001').addEventListener('click', updateSection1NextButtonState);

    // Initial check when the page first loads
    // This handles cases where the input field might be pre-filled immediately on load.
    updateSection1NextButtonState();

    // Add a small timeout to re-check for autofilled values,
    // as autofill can sometimes happen slightly after DOMContentLoaded.
    setTimeout(updateSection1NextButtonState, 100); // Check again after 100 milliseconds
  });
document.addEventListener('DOMContentLoaded', function() {
    // --- Section 3 Elements ---
    // Select all radio buttons with the name "cat-0-ageStage"
    // (Assuming you've updated the name attribute to 'cat-0-ageStage' in your HTML for consistency)
    const ageStageRadios = document.querySelectorAll('input[name="cat-0-ageStage"]');

    // Get references to the "Siguiente" button's wrapper and the button itself for Section 3
    // CORRECTED: Using '.dog-age.next' to target the specific button wrapper
    const section3NextButtonWrapper = document.querySelector('.dog-age.next');
    const section3NextButton = section3NextButtonWrapper ? section3NextButtonWrapper.querySelector('button') : null;

    /**
     * Updates the disabled state of the "Siguiente" button for Section 3.
     * The button is enabled if at least one age stage radio button is selected.
     */
    function updateSection3NextButtonState() {
      if (!section3NextButtonWrapper || !section3NextButton) {
        // Exit if the button elements aren't found on the page
        console.warn("Section 3 next button elements not found. Please ensure the HTML selector is correct.");
        return;
      }

      let isAnyRadioSelected = false;
      // Loop through all age stage radio buttons to check if any are checked
      ageStageRadios.forEach(radio => {
        if (radio.checked) {
          isAnyRadioSelected = true;
        }
      });

      if (isAnyRadioSelected) {
        // If a radio button is selected, enable the button
        section3NextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        section3NextButton.removeAttribute('disabled');
      } else {
        // If no radio button is selected, disable the button
        section3NextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        section3NextButton.setAttribute('disabled', '');
      }
    }

    // Add event listeners to each radio button
    // The 'change' event is ideal for radio buttons as it fires when selection changes.
    ageStageRadios.forEach(radio => {
      radio.addEventListener('change', updateSection3NextButtonState);
    });

    // Perform an initial check when the page loads
    // This handles cases where a radio button might be pre-selected (e.g., from user data or browser cache).
    updateSection3NextButtonState();
  });
 document.addEventListener('DOMContentLoaded', function() {
    // --- Section 4 Elements ---
    // Get references to the breed input fields
    const breedInput1 = document.getElementById('downshift-3-inputx');
    const breedInput2 = document.getElementById('downshift-3-input1x');

    // Get a reference to the 'Siguiente' button for Section 5.
    // CORRECTED: Targeting the button wrapper using its specific class 'dog-breed'
    const section5NextButtonWrapper = document.querySelector('.dog-breed.next');
    const section5NextButton = section5NextButtonWrapper ? section5NextButtonWrapper.querySelector('button') : null;

    /**
     * Updates the disabled state of the "Siguiente" button for Section 5.
     * The button is enabled if either of the breed input fields has text.
     */
    function updateSection5NextButtonState() {
      if (!section5NextButtonWrapper || !section5NextButton) {
        // Exit if the button elements aren't found on the page
        console.warn("Section 5 next button elements not found. Please ensure the HTML selector '.dog-breed.next' is correct.");
        return;
      }

      // Check if either input field contains any non-whitespace text
      const isInput1Filled = breedInput1.value.trim() !== '';
      const isInput2Filled = breedInput2.value.trim() !== '';

      if (isInput1Filled || isInput2Filled) {
        // If at least one input has text, enable the button
        section5NextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        section5NextButton.removeAttribute('disabled');
      } else {
        // If both inputs are empty, disable the button
        section5NextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        section5NextButton.setAttribute('disabled', '');
      }
    }

    // Add event listeners to both breed input fields
    breedInput1.addEventListener('input', updateSection5NextButtonState);
    breedInput2.addEventListener('input', updateSection5NextButtonState);

    // Add a small timeout to re-check for autofilled values,
    // as autofill can sometimes happen slightly after DOMContentLoaded.
    setTimeout(updateSection5NextButtonState, 100);

    // Initial check when the page loads
    updateSection5NextButtonState();
  });



document.addEventListener('DOMContentLoaded', function() {
    // --- Section 5b Elements (Food Type & Eating Habits) ---
    // Select all checkboxes for food types
    const foodTypeCheckboxes = document.querySelectorAll('input[name="cat-0-food"]');
    // Select all radio buttons for eating habits
    const eatingHabitRadios = document.querySelectorAll('input[name="cat-eating-habit"]');

    // Get the "Siguiente" button for this specific section (Section 5b)
    // CORRECTED: Using the specific class 'dog-eating-habit' on the button's wrapper
    const section5bNextButtonWrapper = document.querySelector('.dog-eating-habit.next');
    const section5bNextButton = section5bNextButtonWrapper ? section5bNextButtonWrapper.querySelector('button') : null;

    /**
     * Updates the disabled state of the "Siguiente" button for Section 5b.
     * The button is enabled if at least one checkbox OR one radio button is selected.
     */
    function updateSection5bNextButtonState() {
      if (!section5bNextButtonWrapper || !section5bNextButton) {
        console.warn("Section 5b next button elements not found. Please ensure the HTML div has class 'dog-eating-habit next'.");
        return;
      }

      let isFoodTypeSelected = false;
      foodTypeCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          isFoodTypeSelected = true;
        }
      });

      let isEatingHabitSelected = false;
      eatingHabitRadios.forEach(radio => {
        if (radio.checked) {
          isEatingHabitSelected = true;
        }
      });

      // The button is enabled if at least one food type is selected OR at least one eating habit is selected
      if (isFoodTypeSelected || isEatingHabitSelected) {
        section5bNextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        section5bNextButton.removeAttribute('disabled');
      } else {
        section5bNextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        section5bNextButton.setAttribute('disabled', '');
      }
    }

    // Add event listeners to all relevant inputs in Section 5b
    foodTypeCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateSection5bNextButtonState);
    });

    eatingHabitRadios.forEach(radio => {
      radio.addEventListener('change', updateSection5bNextButtonState);
    });

    // Initial check when the page loads to handle pre-selected options
    updateSection5bNextButtonState();
  });
document.addEventListener('DOMContentLoaded', function() {
    // --- Section 6 Elements ---
    // Select all radio buttons for "Cat Body"
    const catBodyRadios = document.querySelectorAll('input[name="cat-body"]');
    // Select all radio buttons for "Cat Activity" (Updated name attribute)
    const catActivityRadios = document.querySelectorAll('input[name="cat-activity"]'); // Changed from dog-activity

    // Get the "Siguiente" button for this specific section (Section 6)
    // Targeting the button wrapper using its specific class 'dog-body-type'
    const section6NextButtonWrapper = document.querySelector('.dog-body-type.next');
    const section6NextButton = section6NextButtonWrapper ? section6NextButtonWrapper.querySelector('button') : null;

    /**
     * Updates the disabled state of the "Siguiente" button for Section 6.
     * The button is enabled if at least one option from 'cat-body' AND
     * at least one option from 'cat-activity' is selected.
     */
    function updateSection6NextButtonState() {
      if (!section6NextButtonWrapper || !section6NextButton) {
        console.warn("Section 6 next button elements not found. Please ensure the HTML div has class 'dog-body-type next'.");
        return;
      }

      let isCatBodySelected = false;
      catBodyRadios.forEach(radio => {
        if (radio.checked) {
          isCatBodySelected = true;
        }
      });

      let isCatActivitySelected = false; // Updated variable name
      // Loop through the 'cat-activity' radios to check for selection
      catActivityRadios.forEach(radio => { // Updated variable name
        if (radio.checked) {
          isCatActivitySelected = true;
        }
      });

      // The button is enabled if a selection is made in BOTH categories
      if (isCatBodySelected && isCatActivitySelected) { // Updated condition
        section6NextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        section6NextButton.removeAttribute('disabled');
      } else {
        section6NextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        section6NextButton.setAttribute('disabled', '');
      }
    }

    // Add event listeners to all relevant inputs in Section 6
    catBodyRadios.forEach(radio => {
      radio.addEventListener('change', updateSection6NextButtonState);
    });

    catActivityRadios.forEach(radio => { // Updated variable name
      radio.addEventListener('change', updateSection6NextButtonState);
    });

    // Initial check when the page loads to handle pre-selected options
    updateSection6NextButtonState();
  });











document.addEventListener('DOMContentLoaded', function() {
    // --- Section 7 Elements ---
    const catWeightInput = document.getElementById('cat-weight');
    const catWeightSlider = document.getElementById('cat-weight-slider-input-0');

    // Section 7 Next Button
    const section7NextButtonWrapper = document.querySelector('.dog-weight.next');
    const section7NextButton = section7NextButtonWrapper ? section7NextButtonWrapper.querySelector('button') : null;

    /**
     * Updates the disabled state of the "Siguiente" button for Section 7.
     * The button enables if the 'cat-weight' input has a numeric value greater than 0.
     */
    function updateSection7NextButtonState() {
      // Safely check if elements exist before proceeding
      if (!section7NextButtonWrapper || !section7NextButton || !catWeightInput) {
        console.warn("Section 7 elements not found. Please ensure all IDs and classes are correct.");
        return; // Exit if critical elements aren't found
      }

      const weightValue = parseFloat(catWeightInput.value); // Convert input value to a number

      // Check if the value is a valid number (not NaN) and greater than 0
      if (!isNaN(weightValue) && weightValue > 0) {
        // Enable the button
        section7NextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
        section7NextButton.removeAttribute('disabled');
      } else {
        // Disable the button
        section7NextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
        section7NextButton.setAttribute('disabled', '');
      }
    }

    // --- Add Event Listeners ---
    // Listen for 'input' changes (user typing)
    catWeightInput.addEventListener('input', updateSection7NextButtonState);

    // Listen for 'change' event (can catch autofill or blur events)
    catWeightInput.addEventListener('change', updateSection7NextButtonState);

    // Listen for changes on the slider
    catWeightSlider.addEventListener('input', function() {
      // Update the text input with the slider's value (converted from grams to kg)
      catWeightInput.value = (parseFloat(catWeightSlider.value) / 1000).toFixed(2);
      // Then, update the button state
      updateSection7NextButtonState();
    });

    // --- Initial Checks on Page Load ---
    // 1. Immediate check on DOMContentLoaded
    updateSection7NextButtonState();

    // 2. Add a small timeout for late autofills or other script interactions.
    // This is a common workaround for autofill issues.
    window.setTimeout(updateSection7NextButtonState, 150); // Check again after 150ms

    // 3. (Optional, more advanced): Listen for 'autocomplete' event (less supported, but can help)
    // catWeightInput.addEventListener('autocomplete', updateSection7NextButtonState);
  });
























































// Script for Section 1: Cat Name Input
document.addEventListener('DOMContentLoaded', function() {
  const catNameInput = document.getElementById('catNameInput-0');
  // Assuming there's a "Next" button in Section 1 to trigger saving and moving to Section 2
  // Replace '.your-section1-next-button-class' with the actual class/ID of your "Next" button in Section 1.
  const section1NextButton = document.querySelector('.your-section1-next-button-class'); 

  // Define a specific localStorage key for the cat name
  const localStorageCatNameKey = 'order_note_cat_name';

  if (catNameInput) {
    // Load and pre-fill if already saved (e.g., user navigated back)
    const savedCatName = localStorage.getItem(localStorageCatNameKey);
    if (savedCatName) {
      catNameInput.value = savedCatName;
      console.log(`Section 1: Pre-filled Cat Name from localStorage: "${savedCatName}"`);
    }

    // Live update localStorage and console on input (optional, but good for feedback)
    catNameInput.addEventListener('input', function() {
      localStorage.setItem(localStorageCatNameKey, this.value.trim());
      console.log(`Section 1: Cat Name input updated and saved: "${this.value.trim()}"`);
    });

    // If there's a specific "Next" button for this section, you might want to confirm save on click
    if (section1NextButton) {
      section1NextButton.addEventListener('click', function() {
        const currentCatName = catNameInput.value.trim();
        localStorage.setItem(localStorageCatNameKey, currentCatName);
        console.log(`Section 1: "Next" button clicked. Cat Name saved to localStorage: "${currentCatName}"`);
      });
    }

  } else {
    console.warn('Section 1: Cat Name Input not found. Script may not function as expected.');
  }
});









// Script for Section 2: Radio Buttons (Dog Gender, Dog Desexed)
document.addEventListener('DOMContentLoaded', function() {
  const dogGenderRadios = document.querySelectorAll('input[name="dog-0-gender"]');
  const dogDesexedRadios = document.querySelectorAll('input[name="dog-0-desexed"]');
  // Assuming there's a "Next" button in Section 2 to trigger saving and moving to the final step
  // Replace '.your-section2-next-button-class' with the actual class/ID of your "Next" button in Section 2.
  const section2NextButton = document.querySelector('.your-section2-next-button-class'); 

  // Define specific localStorage keys for these radio groups
  const localStorageDogGenderKey = 'order_note_dog_gender';
  const localStorageDogDesexedKey = 'order_note_dog_desexed';

  // Function to load and set radio button state
  function loadRadioState(radios, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      radios.forEach(radio => {
        if (radio.value === savedValue) {
          radio.checked = true;
        }
      });
      console.log(`Section 2: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  // Function to save radio button state
  function saveRadioState(radios, localStorageKey) {
    let selectedValue = '';
    radios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });
    localStorage.setItem(localStorageKey, selectedValue);
    console.log(`Section 2: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
    return selectedValue; // Return for immediate use if needed
  }

  // Process Dog Gender radios
  if (dogGenderRadios.length > 0) {
    loadRadioState(dogGenderRadios, localStorageDogGenderKey);
    dogGenderRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        saveRadioState(dogGenderRadios, localStorageDogGenderKey);
      });
    });
  } else {
    console.warn('Section 2: Dog Gender radio buttons not found.');
  }

  // Process Dog Desexed radios
  if (dogDesexedRadios.length > 0) {
    loadRadioState(dogDesexedRadios, localStorageDogDesexedKey);
    dogDesexedRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        saveRadioState(dogDesexedRadios, localStorageDogDesexedKey);
      });
    });
  } else {
    console.warn('Section 2: Dog Desexed radio buttons not found.');
  }

  // If there's a specific "Next" button for this section, you might want to confirm save on click
  if (section2NextButton) {
    section2NextButton.addEventListener('click', function() {
      saveRadioState(dogGenderRadios, localStorageDogGenderKey);
      saveRadioState(dogDesexedRadios, localStorageDogDesexedKey);
      console.log('Section 2: "Next" button clicked. All radio states saved to localStorage.');
    });
  }
});










// Script for Section 3: Cat Age Stage Radio Buttons (UPDATED 'name' ATTRIBUTE)
document.addEventListener('DOMContentLoaded', function() {
  // --- IMPORTANT: Updated selector for 'cat-0-ageStage' ---
  const catAgeStageRadios = document.querySelectorAll('input[name="cat-0-ageStage"]');
  
  // Assuming there's a "Next" button in Section 3 to trigger saving and moving to the final step
  // Replace '.your-section3-next-button-class' with the actual class or ID of your "Next" button in Section 3.
  const section3NextButton = document.querySelector('.your-section3-next-button-class'); 

  // Define a specific localStorage key for this radio group
  const localStorageCatAgeStageKey = 'order_note_cat_age_stage'; // Changed key name for clarity

  // Function to load and set radio button state
  function loadRadioState(radios, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      radios.forEach(radio => {
        if (radio.value === savedValue) {
          radio.checked = true;
        }
      });
      console.log(`Section 3: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  // Function to save radio button state
  function saveRadioState(radios, localStorageKey) {
    let selectedValue = '';
    radios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });
    localStorage.setItem(localStorageKey, selectedValue);
    console.log(`Section 3: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
    return selectedValue; // Return for immediate use if needed
  }

  // Process Cat Age Stage radios
  if (catAgeStageRadios.length > 0) { // Changed variable name
    loadRadioState(catAgeStageRadios, localStorageCatAgeStageKey); // Changed variable name
    catAgeStageRadios.forEach(radio => { // Changed variable name
      radio.addEventListener('change', function() {
        saveRadioState(catAgeStageRadios, localStorageCatAgeStageKey); // Changed variable name
      });
    });
  } else {
    console.warn('Section 3: Cat Age Stage radio buttons not found.'); // Changed message
  }

  // If there's a specific "Next" button for this section, you might want to confirm save on click
  if (section3NextButton) {
    section3NextButton.addEventListener('click', function() {
      saveRadioState(catAgeStageRadios, localStorageCatAgeStageKey); // Changed variable name
      console.log('Section 3: "Next" button clicked. Cat Age Stage state saved to localStorage.'); // Changed message
    });
  }
});












document.addEventListener('DOMContentLoaded', function() {
    console.log('Section 4 script loaded!'); // Debugging line

    const mainBreedInput = document.getElementById('downshift-3-inputx');

    // --- UPDATED SELECTOR FOR YOUR BUTTON ---
    // This targets the button inside the div with class 'dog-breed' and 'next'.
    const section4NextButton = document.querySelector('.dog-breed.next .button-module__button___Epy33');

    const localStorageMainBreedKey = 'order_note_main_breed';

    // Function to load and pre-fill text input
    function loadTextInputState(inputElement, localStorageKey) {
        if (inputElement) {
            const savedValue = localStorage.getItem(localStorageKey);
            if (savedValue) {
                inputElement.value = savedValue;
                console.log(`Section 4: Pre-filled text input "${localStorageKey}" from localStorage: "${savedValue}"`);
            }
        }
    }

    // Function to save text input state (and log it)
    function saveTextInputState(inputElement, localStorageKey) {
        if (inputElement) {
            const value = inputElement.value.trim();
            localStorage.setItem(localStorageKey, value);
            console.log(`Section 4: Text input "${localStorageKey}" updated and saved: "${value}"`);
            return value;
        }
        return '';
    }

    // --- Function to check input validity and enable/disable the button ---
    function updateNextButtonState() {
        const mainBreedValue = mainBreedInput ? mainBreedInput.value.trim() : '';
        const shouldEnableButton = mainBreedValue.length > 0;

        if (section4NextButton) {
            if (shouldEnableButton) {
                section4NextButton.removeAttribute('disabled');
                // You specifically mentioned "remove the disabled class".
                // The HTML you provided has `stickynavigation-module__disabled___1GDwt` on the *parent div*.
                // If you want to remove that class from the parent div when the button is enabled, add this:
                const parentDiv = section4NextButton.closest('.dog-breed.next');
                if (parentDiv) {
                    parentDiv.classList.remove('stickynavigation-module__disabled___1GDwt');
                }
                console.log('Section 4: Next button enabled.');
            } else {
                section4NextButton.setAttribute('disabled', 'true');
                // Re-add the disabled class to the parent div if needed for styling
                const parentDiv = section4NextButton.closest('.dog-breed.next');
                if (parentDiv) {
                    parentDiv.classList.add('stickynavigation-module__disabled___1GDwt');
                }
                console.log('Section 4: Next button disabled.');
            }
        }
    }

    // --- Initialize Main Breed Input & Attach Event Listener for Typing ---
    if (mainBreedInput) {
        loadTextInputState(mainBreedInput, localStorageMainBreedKey);
        mainBreedInput.addEventListener('input', function() {
            saveTextInputState(mainBreedInput, localStorageMainBreedKey);
            updateNextButtonState(); // Update button state based on main breed input
        });
    } else {
        console.warn('Section 4: Main Breed input (downshift-3-inputx) not found.');
    }

    // --- "Next" Button Integration ---
    if (section4NextButton) {
        // Initial state check when the page loads
        updateNextButtonState();

        section4NextButton.addEventListener('click', function() {
            // Only proceed if the button is not disabled
            if (!section4NextButton.hasAttribute('disabled')) {
                saveTextInputState(mainBreedInput, localStorageMainBreedKey);
                console.log('Section 4: "Next" button clicked. Main breed input state saved to localStorage.');
                // Add any navigation logic here, e.g., window.location.href = 'next-page.html';
            } else {
                console.log('Section 4: Next button is disabled. Cannot proceed.');
            }
        });
    } else {
        console.warn('Section 4: Next button not found. Button enabling functionality will not work.');
    }
});








document.addEventListener('DOMContentLoaded', function() {
    // --- Section 8 Elements ---
    // Health Issues
    const healthRadios = document.querySelectorAll('input[name="cat-0-health"]');
    const healthYesRadio = document.getElementById('cat-0-some');
    const healthNoRadio = document.getElementById('cat-0-none');
    const healthIssueInputContainer = document.getElementById('health-issues');
    const healthIssueInput = document.getElementById('health-issue-input-0x');

    // Allergies - Targeting individual checkboxes by ID
    const nothingAllergyCheckbox = document.getElementById('cat-0-nothing');
    const huevoAllergyCheckbox = document.getElementById('cat-0-Huevo');
    const porkAllergyCheckbox = document.getElementById('cat-0-Pork');
    const chickenAllergyCheckbox = document.getElementById('cat-0-Chicken');
    const beefAllergyCheckbox = document.getElementById('cat-0-Beef');
    const sardinaAllergyCheckbox = document.getElementById('cat-0-Sardina');

    // Combine all allergy checkboxes into an array for easy iteration
    const allIndividualAllergyCheckboxes = [
        nothingAllergyCheckbox,
        huevoAllergyCheckbox,
        porkAllergyCheckbox,
        chickenAllergyCheckbox,
        beefAllergyCheckbox,
        sardinaAllergyCheckbox
    ].filter(checkbox => checkbox !== null); // Filter out any nulls if an ID isn't found

    // Section 8 Next Button
    const section8NextButtonWrapper = document.querySelector('.dog-health-issues.next');
    const section8NextButton = section8NextButtonWrapper ? section8NextButtonWrapper.querySelector('button') : null;

    /**
     * Toggles the visibility of the health issue description input.
     */
    function toggleHealthIssueInput() {
        if (healthYesRadio.checked) {
            healthIssueInputContainer.classList.remove('hidden');
        } else {
            healthIssueInputContainer.classList.add('hidden');
            healthIssueInput.value = ''; // Clear input if "NO" is selected
        }
        updateSection8NextButtonState();
    }

    /**
     * This function now simply updates the button state.
     * The specific mutual exclusivity logic for "Nada" and other checkboxes is removed.
     */
    function handleAllergyCheckboxChange() {
        updateSection8NextButtonState();
    }

    /**
     * Updates the disabled state of the "Siguiente" button for Section 8.
     */
    function updateSection8NextButtonState() {
        if (!section8NextButtonWrapper || !section8NextButton) {
            console.warn("Section 8 next button elements not found. Ensure HTML div has class 'dog-health-issues next'.");
            return;
        }

        let isHealthSelectionValid = false;
        if (healthNoRadio.checked) {
            isHealthSelectionValid = true;
        } else if (healthYesRadio.checked && healthIssueInput.value.trim() !== '') {
            isHealthSelectionValid = true;
        }

        let isAllergySelected = false;
        // Check if ANY of the individually targeted allergy checkboxes are checked
        for (const checkbox of allIndividualAllergyCheckboxes) {
            if (checkbox && checkbox.checked) { // Add a null check for safety
                isAllergySelected = true;
                break; // No need to check further once one is found
            }
        }

        if (isHealthSelectionValid && isAllergySelected) {
            section8NextButtonWrapper.classList.remove('stickynavigation-module__disabled___1GDwt');
            section8NextButton.removeAttribute('disabled');
        } else {
            section8NextButtonWrapper.classList.add('stickynavigation-module__disabled___1GDwt');
            section8NextButton.setAttribute('disabled', '');
        }
    }

    // --- Add Event Listeners ---
    // Health Issues radios
    healthRadios.forEach(radio => {
        radio.addEventListener('change', toggleHealthIssueInput);
    });

    // Health Issue text input (only if 'SÍ' is selected and visible)
    healthIssueInput.addEventListener('input', updateSection8NextButtonState);

    // Allergy checkboxes (will now simply trigger button state update)
    allIndividualAllergyCheckboxes.forEach(checkbox => {
        if (checkbox) { // Only add listener if the checkbox element exists
            checkbox.addEventListener('change', handleAllergyCheckboxChange);
        }
    });

    // Initial checks on page load to set correct states
    toggleHealthIssueInput(); // This also calls updateSection8NextButtonState() initially
});























































// Script for Section 5: Current Food (Checkboxes) & Eating Habit (Radio Buttons) - UPDATED NAMES
document.addEventListener('DOMContentLoaded', function() {
  console.log('Section 5 script loaded!'); // Debugging line

  // Checkboxes for 'Current Food' - UPDATED NAME 'cat-0-food'
  const currentFoodCheckboxes = document.querySelectorAll('input[name="cat-0-food"][type="checkbox"]');
  // Radio buttons for 'Eating Habit' - UPDATED NAME 'cat-eating-habit'
  const eatingHabitRadios = document.querySelectorAll('input[name="cat-eating-habit"][type="radio"]');

  // Assuming there's a "Next" button in Section 5 to trigger saving and moving to the final step
  // Replace '.your-section5-next-button-class' with the actual class/ID of your "Next" button in Section 5.
  const section5NextButton = document.querySelector('.your-section5-next-button-class'); 

  // Define specific localStorage keys (no change to keys, as they are generic enough)
  const localStorageCurrentFoodKey = 'order_note_current_food';
  const localStorageEatingHabitKey = 'order_note_eating_habit';

  // --- Function to load and set Checkbox states ---
  function loadCheckboxState(checkboxes, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      const savedSelections = savedValue.split(','); // Assuming stored as comma-separated
      checkboxes.forEach(checkbox => {
        if (savedSelections.includes(checkbox.value)) {
          checkbox.checked = true;
        }
      });
      console.log(`Section 5: Pre-filled checkboxes "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  // --- Function to save Checkbox states ---
  function saveCheckboxState(checkboxes, localStorageKey) {
    const selectedValues = [];
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedValues.push(checkbox.value);
      }
    });
    const valueToSave = selectedValues.join(','); // Save as comma-separated string
    localStorage.setItem(localStorageKey, valueToSave);
    console.log(`Section 5: Checkboxes "${localStorageKey}" updated and saved: "${valueToSave}"`);
    return valueToSave;
  }

  // --- Function to load and set Radio button state (reused from previous sections) ---
  function loadRadioState(radios, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      radios.forEach(radio => {
        if (radio.value === savedValue) {
          radio.checked = true;
        }
      });
      console.log(`Section 5: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  // --- Function to save Radio button state (reused from previous sections) ---
  function saveRadioState(radios, localStorageKey) {
    let selectedValue = '';
    radios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });
    localStorage.setItem(localStorageKey, selectedValue);
    console.log(`Section 5: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
    return selectedValue;
  }

  // --- Process Current Food Checkboxes ---
  if (currentFoodCheckboxes.length > 0) {
    loadCheckboxState(currentFoodCheckboxes, localStorageCurrentFoodKey);
    currentFoodCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        saveCheckboxState(currentFoodCheckboxes, localStorageCurrentFoodKey);
      });
    });
  } else {
    console.warn('Section 5: Current Food checkboxes not found.');
  }

  // --- Process Eating Habit Radio Buttons ---
  if (eatingHabitRadios.length > 0) {
    loadRadioState(eatingHabitRadios, localStorageEatingHabitKey);
    eatingHabitRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        saveRadioState(eatingHabitRadios, localStorageEatingHabitKey);
      });
    });
  } else {
    console.warn('Section 5: Eating Habit radio buttons not found.');
  }

  // If there's a specific "Next" button for this section, confirm save on click
  if (section5NextButton) {
    section5NextButton.addEventListener('click', function() {
      saveCheckboxState(currentFoodCheckboxes, localStorageCurrentFoodKey);
      saveRadioState(eatingHabitRadios, localStorageEatingHabitKey);
      console.log('Section 5: "Next" button clicked. All states saved to localStorage.');
    });
  } else {
    console.warn('Section 5: Next button not found. Automatic saving on change is active.');
  }
});










// Script for Section 6: Cat Body (Radio Buttons) & Cat Activity (Radio Buttons)
document.addEventListener('DOMContentLoaded', function() {
  console.log('Section 6 script loaded!'); // Debugging line

  // Radio buttons for 'Cat Body Shape'
  const catBodyRadios = document.querySelectorAll('input[name="cat-body"][type="radio"]');
  // Radio buttons for 'Cat Activity Level'
  const catActivityRadios = document.querySelectorAll('input[name="cat-activity"][type="radio"]');

  // Assuming there's a "Next" button in Section 6 to trigger saving and moving to the final step
  // Replace '.your-section6-next-button-class' with the actual class/ID of your "Next" button in Section 6.
  const section6NextButton = document.querySelector('.your-section6-next-button-class'); 

  // Define specific localStorage keys
  const localStorageCatBodyKey = 'order_note_cat_body';
  const localStorageCatActivityKey = 'order_note_cat_activity';

  // --- Function to load and set Radio button state (reused) ---
  function loadRadioState(radios, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      radios.forEach(radio => {
        if (radio.value === savedValue) {
          radio.checked = true;
        }
      });
      console.log(`Section 6: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  // --- Function to save Radio button state (reused) ---
  function saveRadioState(radios, localStorageKey) {
    let selectedValue = '';
    radios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });
    localStorage.setItem(localStorageKey, selectedValue);
    console.log(`Section 6: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
    return selectedValue;
  }

  // --- Process Cat Body Shape Radios ---
  if (catBodyRadios.length > 0) {
    loadRadioState(catBodyRadios, localStorageCatBodyKey);
    catBodyRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        saveRadioState(catBodyRadios, localStorageCatBodyKey);
      });
    });
  } else {
    console.warn('Section 6: Cat Body radio buttons not found.');
  }

  // --- Process Cat Activity Level Radios ---
  if (catActivityRadios.length > 0) {
    loadRadioState(catActivityRadios, localStorageCatActivityKey);
    catActivityRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        saveRadioState(catActivityRadios, localStorageCatActivityKey);
      });
    });
  } else {
    console.warn('Section 6: Cat Activity radio buttons not found.');
  }

  // If there's a specific "Next" button for this section, confirm save on click
  if (section6NextButton) {
    section6NextButton.addEventListener('click', function() {
      saveRadioState(catBodyRadios, localStorageCatBodyKey);
      saveRadioState(catActivityRadios, localStorageCatActivityKey);
      console.log('Section 6: "Next" button clicked. All states saved to localStorage.');
    });
  } else {
    console.warn('Section 6: Next button not found. Automatic saving on change is active.');
  }
});








// Script for Section 7: Weight Input (Number & Slider) - UPDATED FOR NEW HTML IDs
document.addEventListener('DOMContentLoaded', function() {
  console.log('Section 7 script loaded!'); // Debugging line

  // --- Updated element IDs based on new HTML ---
  const weightInput = document.getElementById('cat-weight'); // Changed ID
  const weightSlider = document.getElementById('cat-weight-slider-input-0'); // Changed ID

  // Assuming there's a "Next" button in Section 7 to trigger saving and moving to the final step
  // Replace '.your-section7-next-button-class' with the actual class/ID of your "Next" button in Section 7.
  const section7NextButton = document.querySelector('.your-section7-next-button-class'); 

  // Define specific localStorage key
  const localStorageWeightKey = 'order_note_weight'; // This key remains consistent

  // Function to load and pre-fill input fields (for both number input and slider)
  function loadWeightInputState() {
    const savedValue = localStorage.getItem(localStorageWeightKey);
    if (savedValue) {
      const savedKg = parseFloat(savedValue);
      if (!isNaN(savedKg)) {
        if (weightInput) {
          weightInput.value = savedKg.toFixed(2); // Set number input
        }
        
        if (weightSlider) {
          // Convert kg to grams for the slider (slider min/max are in grams)
          let sliderValue = savedKg * 1000; 
          // Clamp slider value within its min/max range
          const sliderMin = parseFloat(weightSlider.min);
          const sliderMax = parseFloat(weightSlider.max);
          sliderValue = Math.max(sliderMin, Math.min(sliderMax, sliderValue));
          
          weightSlider.value = sliderValue; // Set slider
        }
        console.log(`Section 7: Pre-filled weight inputs from localStorage: "${savedValue} kg"`);
      }
    }
  }

  // Function to save the weight input state
  function saveWeightInputState() {
    if (weightInput) {
      const value = weightInput.value.trim();
      localStorage.setItem(localStorageWeightKey, value);
      console.log(`Section 7: Weight input "${localStorageWeightKey}" updated and saved: "${value}" kg`);
      return value;
    }
    return '';
  }

  // --- Initialize state on page load ---
  loadWeightInputState();

  // --- Synchronize Slider to Number Input ---
  if (weightSlider && weightInput) {
    weightSlider.addEventListener('input', function() {
      // Convert slider value (grams) to kg and update the number input
      const sliderKg = parseFloat(this.value) / 1000;
      weightInput.value = sliderKg.toFixed(2); // Format to 2 decimal places

      // Save the state immediately as the slider changes
      saveWeightInputState();
    });
  } else {
    console.warn('Section 7: Weight slider or number input not found.');
  }

  // --- Synchronize Number Input to Slider ---
  // Also handles saving when user types directly
  if (weightInput && weightSlider) {
    weightInput.addEventListener('input', function() {
      // Convert number input (kg) to grams and update the slider
      const inputKg = parseFloat(this.value);
      if (!isNaN(inputKg)) {
        let sliderValue = inputKg * 1000;
        // Clamp value to slider's min/max
        const sliderMin = parseFloat(weightSlider.min);
        const sliderMax = parseFloat(weightSlider.max);
        sliderValue = Math.max(sliderMin, Math.min(sliderMax, sliderValue));
        weightSlider.value = sliderValue;
      }
      // Save the state after input changes
      saveWeightInputState();
    });
  } else {
    console.warn('Section 7: Weight number input or slider not found.');
  }

  // If there's a specific "Next" button for this section, confirm save on click
  if (section7NextButton) {
    section7NextButton.addEventListener('click', function() {
      saveWeightInputState(); // Ensure the latest value is saved on next button click
      console.log('Section 7: "Next" button clicked. Weight input state saved to localStorage.');
    });
  } else {
    console.warn('Section 7: Next button not found. Automatic saving on input/slider change is active.');
  }
});












// Section 8: Allergy Interaction Rules and Data Collection
document.addEventListener('DOMContentLoaded', function() {
    console.log('Section 8 script loaded with allergy interaction rules!');

    // --- Health Issue Elements ---
    const catHealthRadios = document.querySelectorAll('input[name="my-cat-form-health"][type="radio"]');
    const healthIssueTextInput = document.getElementById('my-cat-form-health-issue-input');

    // --- Allergy Elements ---
    const allergyNothingCheckbox = document.getElementById('cat-0-nothing');
    const allOtherAllergyCheckboxes = document.querySelectorAll('.yes-allergy');

    // Combined list for saving all allergy checkbox states
    const allAllergyCheckboxesForSaving = document.querySelectorAll(
        '#cat-0-nothing, .yes-allergy' // Selects Nada by ID and others by class
    );

    // Next button for Section 8
    const section8NextButton = document.querySelector('.your-section8-next-button-class');

    // Local Storage Keys for Section 8
    const localStorageHealthStatusKey = 'order_note_health_status';
    const localStorageHealthDetailsKey = 'order_note_health_details';
    // Removed: localStorageAllergiesKey is now assumed to be managed by another script for saving.
    const localStorageSelectedIngredientsKey = 'order_note_selected_ingredients';

    // --- NEW: Define the full list of available ingredients ---
    // Ensure these values match the 'value' attributes of your actual ingredient checkboxes (if they exist).
    // These are also assumed to be lowercase for consistent comparison.
    const allAvailableIngredients = ['pollo', 'carne', 'pernil'];

    // --- Data Persistence Functions ---

    function loadRadioState(radios, localStorageKey) {
        const savedValue = localStorage.getItem(localStorageKey);
        if (savedValue) {
            radios.forEach(radio => {
                if (radio.value === savedValue) {
                    radio.checked = true;
                }
            });
            console.log(`Section 8: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
        }
    }

    function saveRadioState(radios, localStorageKey) {
        let selectedValue = '';
        radios.forEach(radio => {
            if (radio.checked) {
                selectedValue = radio.value;
            }
        });
        localStorage.setItem(localStorageKey, selectedValue);
        console.log(`Section 8: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
    }

    function loadTextInputState(inputElement, localStorageKey) {
        if (inputElement) {
            const savedValue = localStorage.getItem(localStorageKey);
            if (savedValue) {
                inputElement.value = savedValue;
                console.log(`Section 8: Pre-filled text input "${localStorageKey}" from localStorage: "${savedValue}"`);
            }
        }
    }

    function saveTextInputState(inputElement, localStorageKey) {
        if (inputElement) {
            const value = inputElement.value.trim();
            localStorage.setItem(localStorageKey, value);
            console.log(`Section 8: Text input "${localStorageKey}" updated and saved: "${value}"`);
        }
    }

    // This function still loads 'order_note_allergies' as input for deriving 'selected_ingredients'
    function loadAllergyCheckboxesState(checkboxes, localStorageKey) {
        const savedValue = localStorage.getItem(localStorageKey);
        if (savedValue) {
            const savedAllergies = savedValue.split(',');
            checkboxes.forEach(checkbox => {
                checkbox.checked = savedAllergies.includes(checkbox.value);
            });
            console.log(`Section 8: Pre-filled allergies from localStorage: "${savedValue}"`);
        } else {
            checkboxes.forEach(checkbox => checkbox.checked = false); // Default to unchecked if no saved data
        }
    }

    // --- MODIFIED: saveAllergyCheckboxesState no longer saves 'allergiesLocalStorageKey' ---
    function saveAllergyCheckboxesState(checkboxes, allergiesLocalStorageKey, selectedIngredientsLocalStorageKey) {
        // We still need to determine the currently *selected* allergies from the UI
        // to correctly derive ingredientsToSave, even if another script saves them.
        const selectedAllergies = [];
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                selectedAllergies.push(checkbox.value);
            }
        });

        // --- REMOVED: No longer saving allergies here ---
        // const allergiesValueToSave = selectedAllergies.join(',');
        // localStorage.setItem(allergiesLocalStorageKey, allergiesValueToSave);
        // console.log(`Section 8: Allergies "${allergiesLocalStorageKey}" (read-only here) updated and saved: "${allergiesValueToSave}"`);

        // --- NEW LOGIC FOR SELECTED INGREDIENTS (UNCHANGED) ---
        const ingredientsToSave = [];
        allAvailableIngredients.forEach(ingredient => {
            // Convert allergy values to lowercase for consistent comparison
            const lowerCaseAllergies = selectedAllergies.map(allergy => allergy.toLowerCase());

            // If the ingredient is NOT in the list of selected allergies, add it
            if (!lowerCaseAllergies.includes(ingredient)) {
                ingredientsToSave.push(ingredient);
            }
        });

        const selectedIngredientsValueToSave = ingredientsToSave.join(',');
        localStorage.setItem(selectedIngredientsLocalStorageKey, selectedIngredientsValueToSave);
        console.log(`Section 8: Selected Ingredients "${selectedIngredientsLocalStorageKey}" updated and saved: "${selectedIngredientsValueToSave}"`);
    }

    // --- NEW FUNCTION: Check and set "Nada" state ---
    function updateNadaCheckboxState() {
        if (!allergyNothingCheckbox || allOtherAllergyCheckboxes.length === 0) {
            return; // Exit if elements aren't found
        }

        // Check if any other allergy checkbox is currently checked
        const anyOtherAllergyChecked = Array.from(allOtherAllergyCheckboxes).some(cb => cb.checked);

        if (!anyOtherAllergyChecked) {
            // If no other allergy is checked, ensure "Nada" is checked
            if (!allergyNothingCheckbox.checked) {
                allergyNothingCheckbox.checked = true;
                console.log('No specific allergies selected, "Nada" automatically checked.');
            }
        } else {
            // If any other allergy is checked, ensure "Nada" is unchecked
            if (allergyNothingCheckbox.checked) {
                allergyNothingCheckbox.checked = false;
                console.log('Specific allergy selected, "Nada" automatically unchecked.');
            }
        }
        // Always save selected ingredients state after this operation
        // Use a dummy string for the allergies key as it's no longer saved here
        saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, 'DUMMY_ALLERGIES_KEY', localStorageSelectedIngredientsKey);
    }


    // --- Apply Persistence Logic & Interaction Rules ---

    // Load state on page load for all elements
    if (catHealthRadios.length > 0) {
        loadRadioState(catHealthRadios, localStorageHealthStatusKey);
    } else {
        console.warn('Section 8: Cat Health radio buttons (name="my-cat-form-health") not found.');
    }

    if (healthIssueTextInput) {
        loadTextInputState(healthIssueTextInput, localStorageHealthDetailsKey);
    } else {
        console.warn('Section 8: Health Issue text input (id="my-cat-form-health-issue-input") not found.');
    }

    // Define localStorageAllergiesKey here, as it's still needed for loading
    const localStorageAllergiesKey = 'order_note_allergies';

    if (allAllergyCheckboxesForSaving.length > 0) {
        // Load allergy states from localStorage (managed by another script for saving)
        loadAllergyCheckboxesState(allAllergyCheckboxesForSaving, localStorageAllergiesKey);
        // After loading allergies, immediately calculate and save the derived ingredients.
        // Use a dummy string for the allergies key as it's no longer saved here
        saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, 'DUMMY_ALLERGIES_KEY', localStorageSelectedIngredientsKey);
        // Ensure Nada state is consistent
        updateNadaCheckboxState();
    } else {
        console.warn('Section 8: Allergy checkboxes not found.');
    }


    // --- Allergy Interaction Rules ---
    if (allergyNothingCheckbox && allOtherAllergyCheckboxes.length > 0) {
        // Listener for "Nada" checkbox
        allergyNothingCheckbox.addEventListener('change', function() {
            console.log('Nada checkbox change event. New checked state:', this.checked);

            if (this.checked) {
                // If "Nada" is checked, uncheck all other allergy checkboxes
                allOtherAllergyCheckboxes.forEach(cb => {
                    cb.checked = false;
                });
            }
            // Update selected ingredients (no longer saving allergies here)
            saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, 'DUMMY_ALLERGIES_KEY', localStorageSelectedIngredientsKey);
        });

        // Listeners for other allergy checkboxes
        allOtherAllergyCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                console.log(`Other allergy checkbox (${this.id}) change event. New checked state:`, this.checked);

                // This internal UI logic remains relevant for the Nada checkbox
                if (this.checked && allergyNothingCheckbox) {
                    allergyNothingCheckbox.checked = false;
                }
                // Update Nada state and selected ingredients
                updateNadaCheckboxState();
            });
        });
    }


    // --- Data is ALSO saved when the 'Next' button for this section is clicked ---
    if (section8NextButton) {
        section8NextButton.addEventListener('click', function() {
            // Explicitly collect and save the CURRENT state of all elements in this section
            saveRadioState(catHealthRadios, localStorageHealthStatusKey);
            saveTextInputState(healthIssueTextInput, localStorageHealthDetailsKey);
            // Ensure Nada state is correct on final save, which also updates selected ingredients
            updateNadaCheckboxState();
            console.log('Section 8: "Next" button clicked. All current states saved to localStorage.');
        });
    } else {
        console.warn('Section 8: Next button not found. Data will be saved on individual allergy changes.');
    }
});









document.addEventListener('DOMContentLoaded', () => {
  const siRadio = document.getElementById('cat-0-some');
  const noRadio = document.getElementById('cat-0-none');
  const healthIssuesDiv = document.getElementById('health-issuesx');
  const healthIssueInput = document.getElementById('health-issue-input-0x');

  // Function to save the input value to localStorage
  const saveInputToLocalStorage = () => {
    localStorage.setItem('healthIssueDescription', healthIssueInput.value);
    console.log('Saved to localStorage:', healthIssueInput.value);
  };

  // Event listener for the "SÍ" radio button
  siRadio.addEventListener('change', () => {
    if (siRadio.checked) {
      healthIssuesDiv.classList.remove('hidden');
      // Load any previously saved value from localStorage
      const savedValue = localStorage.getItem('healthIssueDescription');
      if (savedValue) {
        healthIssueInput.value = savedValue;
      }
      healthIssueInput.focus(); // Optional: Focus on the input field
    }
  });

  // Event listener for the "NO" radio button
  noRadio.addEventListener('change', () => {
    if (noRadio.checked) {
      healthIssuesDiv.classList.add('hidden');
      // Optionally clear the input and localStorage when "NO" is selected
      healthIssueInput.value = '';
      localStorage.removeItem('healthIssueDescription');
    }
  });

  // Event listener for input changes to instantly save to localStorage
  healthIssueInput.addEventListener('input', saveInputToLocalStorage);

  // Initial check on page load in case a radio button was already checked (e.g., due to browser back/forward)
  if (siRadio.checked) {
    healthIssuesDiv.classList.remove('hidden');
    const savedValue = localStorage.getItem('healthIssueDescription');
    if (savedValue) {
      healthIssueInput.value = savedValue;
    }
  }
});




















// Section 8: Allergy Interaction Rules and Data Collection - MODIFIED to include raw data log
document.addEventListener('DOMContentLoaded', function() {
  console.log('Section 8 script loaded with allergy interaction rules!');

  // --- Health Issue Elements ---
  const catHealthRadios = document.querySelectorAll('input[name="my-cat-form-health"][type="radio"]');
  const healthIssueTextInput = document.getElementById('my-cat-form-health-issue-input');

  // --- Allergy Elements ---
  const allergyNothingCheckbox = document.getElementById('cat-0-nothing');
  const allOtherAllergyCheckboxes = document.querySelectorAll('.yes-allergy');  
  const allAllergyCheckboxesForSaving = document.querySelectorAll(
    '#cat-0-nothing, .yes-allergy'  
  );

  // Next button for Section 8
  const section8NextButton = document.getElementById('doghealth-final'); 

  // Define Local Storage Keys for Sections 7 and 8
  const localStorageHealthStatusKey = 'order_note_health_status';
  const localStorageHealthDetailsKey = 'order_note_health_details';
  const localStorageAllergiesKey = 'order_note_allergies';  
  const localStorageWeightKey = 'order_note_weight'; // From Section 7 (important for plan update)
  const localStorageCatNameKey = 'order_note_cat_name'; // Ensure this key is defined here if used by Section 8

  // --- Data Persistence Functions (Unchanged) ---
  function loadRadioState(radios, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      radios.forEach(radio => {
        if (radio.value === savedValue) {
          radio.checked = true;
        }
      });
      console.log(`Section 8: Pre-filled radio "${localStorageKey}" from localStorage: "${savedValue}"`);
    }
  }

  function saveRadioState(radios, localStorageKey) {
    let selectedValue = '';
    radios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });
    localStorage.setItem(localStorageKey, selectedValue);
    console.log(`Section 8: Radio "${localStorageKey}" updated and saved: "${selectedValue}"`);
  }

  function loadTextInputState(inputElement, localStorageKey) {
    if (inputElement) {
      const savedValue = localStorage.getItem(localStorageKey);
      if (savedValue) {
        inputElement.value = savedValue;
        console.log(`Section 8: Pre-filled text input "${localStorageKey}" from localStorage: "${savedValue}"`);
      }
    }
  }

  function saveTextInputState(inputElement, localStorageKey) {
    if (inputElement) {
      const value = inputElement.value.trim();
      localStorage.setItem(localStorageKey, value);
      console.log(`Section 8: Text input "${localStorageKey}" updated and saved: "${value}"`);
    }
  }

  function loadAllergyCheckboxesState(checkboxes, localStorageKey) {
    const savedValue = localStorage.getItem(localStorageKey);
    if (savedValue) {
      const savedAllergies = savedValue.split(',');
      checkboxes.forEach(checkbox => {
        checkbox.checked = savedAllergies.includes(checkbox.value);
      });
      console.log(`Section 8: Pre-filled allergies from localStorage: "${savedValue}"`);
    } else {
      checkboxes.forEach(checkbox => checkbox.checked = false);  
    }
  }

  function saveAllergyCheckboxesState(checkboxes, localStorageKey) {
    const selectedAllergies = [];
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedAllergies.push(checkbox.value);
      }
    });
    const valueToSave = selectedAllergies.join(',');
    localStorage.setItem(localStorageKey, valueToSave);
    console.log(`Section 8: Allergies "${localStorageKey}" updated and saved: "${valueToSave}"`);
  }

  // --- Apply Persistence Logic & Interaction Rules ---
  if (catHealthRadios.length > 0) {
    loadRadioState(catHealthRadios, localStorageHealthStatusKey);
  } else {
    console.warn('Section 8: Cat Health radio buttons not found.');
  }

  if (healthIssueTextInput) {
    loadTextInputState(healthIssueTextInput, localStorageHealthDetailsKey);
  } else {
    console.warn('Section 8: Health Issue text input not found.');
  }

  if (allAllergyCheckboxesForSaving.length > 0) {
    loadAllergyCheckboxesState(allAllergyCheckboxesForSaving, localStorageAllergiesKey);
  } else {
    console.warn('Section 8: Allergy checkboxes not found.');
  }

  // --- Allergy Interaction Rules ---
  if (allergyNothingCheckbox && allOtherAllergyCheckboxes.length > 0) {
    allergyNothingCheckbox.addEventListener('change', function() {
      console.log('Nada checkbox change event. New checked state:', this.checked);

      if (this.checked) {
        allOtherAllergyCheckboxes.forEach(cb => {
          cb.checked = false;
        });
      }
      saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, localStorageAllergiesKey);  
    });

    allOtherAllergyCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        console.log(`Other allergy checkbox (${this.id}) change event. New checked state:`, this.checked);

        if (this.checked && allergyNothingCheckbox) {
          allergyNothingCheckbox.checked = false;
        }
        saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, localStorageAllergiesKey);  
      });
    });
  }

  // --- Event Listener for doghealth-final button ---
  if (section8NextButton) {
    section8NextButton.addEventListener('click', function() {
      // 1. Ensure all current section 8 data is saved
      saveRadioState(catHealthRadios, localStorageHealthStatusKey);
      saveTextInputState(healthIssueTextInput, localStorageHealthDetailsKey);
      saveAllergyCheckboxesState(allAllergyCheckboxesForSaving, localStorageAllergiesKey);
      
      console.log('Section 8: "Next" button (doghealth-final) clicked. All current states saved to localStorage.');

      // 2. IMPORTANT: Re-trigger the Recommended Plan display update with the newly saved data
      if (typeof window.updateRecommendedPlanDisplay === 'function') {
          console.log('Section 8: Triggering Recommended Plan display update...');
          window.updateRecommendedPlanDisplay();
      } else {
          console.warn('Section 8: updateRecommendedPlanDisplay function not found. Cannot update plan dynamically.');
      }

      // 3. NEW: Display all collected data from localStorage to console (raw summary)
      if (typeof window.displayCollectedData === 'function') {
          console.log('Section 8: Displaying collected raw data...');
          window.displayCollectedData();
      } else {
          console.warn('Section 8: displayCollectedData function not found. Cannot display raw data summary.');
      }

      // If this button also navigates to the next page, ensure that happens after this logic.
      // You might need to add `window.location.href = 'next-page-url.html';` or similar here.
    });
  } else {
    console.warn('Section 8: doghealth-final button not found. Save function will not be triggered.');
  }
});

// IMPORTANT: Define displayCollectedData globally so it can be accessed from the button click listener.
window.displayCollectedData = function() {
    const collectedData = [];

    // --- Define all data points to collect and display ---
    // Make sure these keys match what you're using to save data in previous sections
    const dataPoints = [
        { key: 'order_note_cat_name', label: 'Cat Name' },
        { key: 'order_note_dog_gender', label: 'Gender' },
        { key: 'order_note_dog_desexed', label: 'Desexed' },
        { key: 'order_note_cat_age_stage', label: 'Age Stage' },
        { key: 'order_note_main_breed', label: 'Main Breed' },        
        { key: 'order_note_cross_breed', label: 'Cross Breed' },
        { key: 'order_note_current_food', label: 'Current Food' },      
        { key: 'order_note_eating_habit', label: 'Eating Habit' },
        { key: 'order_note_cat_body', label: 'Cat Body' },            
        { key: 'order_note_cat_activity', label: 'Cat Activity' },
        { key: 'order_note_weight', label: 'Weight (kg)' },
        { key: 'order_note_health_status', label: 'Health Status' },
        { key: 'order_note_health_details', label: 'Health Details' },
        { key: 'order_note_allergies', label: 'Allergies' }
    ];

    dataPoints.forEach(point => {
        const value = localStorage.getItem(point.key);
        if (value && value.trim() !== '') {
            collectedData.push(`${point.label}: ${value}`);
        }
    });

    const combinedString = collectedData.join('\n'); // Join with newlines for readability
    console.log('\n--- Collected data (raw) from Sections 1-8 ---'); // Clear header
    console.log(combinedString); // Just log the string
    console.log('------------------------------------------');
};










  // 11th Section


document.addEventListener('DOMContentLoaded', function() {
  console.log('--- Payment Selector Saver Script Loaded ---');

  // Get references to the radio buttons by their name attribute
  const paymentRadios = document.querySelectorAll('input[name="payment-selectorr"]');
  // Define the localStorage key for the payment selection
  const localStoragePaymentTypeKey = 'order_note_payment_type';

  // Function to save the selected payment type
  function saveSelectedPaymentType() {
    let selectedValue = '';
    paymentRadios.forEach(radio => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    });

    if (selectedValue) {
      localStorage.setItem(localStoragePaymentTypeKey, selectedValue);
      console.log(`DEBUG: Payment type saved to localStorage: ${selectedValue}`);
    } else {
      console.warn('No payment option selected. Nothing saved to localStorage.');
    }
  }

  // Add event listeners to the radio buttons
  paymentRadios.forEach(radio => {
    radio.addEventListener('change', saveSelectedPaymentType);
  });

  // Call the function once on load to save the initial (checked) state
  // This is important because 'auto' is checked by default in your HTML
  saveSelectedPaymentType();
});











// 3rd step auto active button if selected

document.addEventListener('DOMContentLoaded', function() {
  const radioButtons = document.querySelectorAll('input[name="cat-0-ageStage"]');
  const nextButtonContainer = document.querySelector('.dog-age.next');
  const nextButton = nextButtonContainer.querySelector('button');

  // Function to update button state
  function updateButtonState() {
    let isAnyRadioChecked = false;
    radioButtons.forEach(radio => {
      if (radio.checked) {
        isAnyRadioChecked = true;
      }
    });

    if (isAnyRadioChecked) {
      nextButton.removeAttribute('disabled');
      nextButtonContainer.classList.remove('stickynavigation-module__disabled___1GDwt');
     
    } else {
      nextButton.setAttribute('disabled', '');
      nextButtonContainer.classList.add('stickynavigation-module__disabled___1GDwt');
   
    }
  }

  // Add event listeners to all radio buttons
  radioButtons.forEach(radio => {
    radio.addEventListener('change', updateButtonState);
  });

  // Initial check in case a radio button is pre-selected on page load
  updateButtonState();
});



// 5th step auto active button if selected

document.addEventListener('DOMContentLoaded', function() {
  const foodCheckboxes = document.querySelectorAll('input[name="cat-0-food"]');
  const eatingHabitRadioButtons = document.querySelectorAll('input[name="cat-eating-habit"]');
  const nextButtonContainer = document.querySelector('.dog-eating-habit.next');
  const nextButton = nextButtonContainer.querySelector('button');

  // Function to update button state based on both sets of inputs
  function updateButtonState() {
    let isAnyFoodChecked = false;
    foodCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        isAnyFoodChecked = true;
      }
    });

    let isAnyEatingHabitSelected = false;
    eatingHabitRadioButtons.forEach(radio => {
      if (radio.checked) {
        isAnyEatingHabitSelected = true;
      }
    });

    // Enable the button only if at least one from each group is selected
    if (isAnyFoodChecked && isAnyEatingHabitSelected) {
      nextButton.removeAttribute('disabled');
      nextButtonContainer.classList.remove('stickynavigation-module__disabled___1GDwt');
    
    } else {
      nextButton.setAttribute('disabled', '');
      nextButtonContainer.classList.add('stickynavigation-module__disabled___1GDwt');
    
    }
  }

  // Add event listeners to all food checkboxes
  foodCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateButtonState);
  });

  // Add event listeners to all eating habit radio buttons
  eatingHabitRadioButtons.forEach(radio => {
    radio.addEventListener('change', updateButtonState);
  });

  // Initial check in case any inputs are pre-selected on page load
  updateButtonState();
});




// 6th step auto active button if selected



document.addEventListener('DOMContentLoaded', function() {
  const bodyShapeRadioButtons = document.querySelectorAll('input[name="cat-body"]');
  const activityRadioButtons = document.querySelectorAll('input[name="cat-activity"]');
  const nextButtonContainer = document.querySelector('.dog-body-type.next');
  const nextButton = nextButtonContainer.querySelector('button');

  // Function to update button state based on both sets of radio buttons
  function updateButtonState() {
    let isBodyShapeSelected = false;
    bodyShapeRadioButtons.forEach(radio => {
      if (radio.checked) {
        isBodyShapeSelected = true;
      }
    });

    let isActivitySelected = false;
    activityRadioButtons.forEach(radio => {
      if (radio.checked) {
        isActivitySelected = true;
      }
    });

    // Enable the button only if one option from each group is selected
    if (isBodyShapeSelected && isActivitySelected) {
      nextButton.removeAttribute('disabled');
      nextButtonContainer.classList.remove('stickynavigation-module__disabled___1GDwt');
    
    } else {
      nextButton.setAttribute('disabled', '');
      nextButtonContainer.classList.add('stickynavigation-module__disabled___1GDwt');
     
    }
  }

  // Add event listeners to all body shape radio buttons
  bodyShapeRadioButtons.forEach(radio => {
    radio.addEventListener('change', updateButtonState);
  });

  // Add event listeners to all activity radio buttons
  activityRadioButtons.forEach(radio => {
    radio.addEventListener('change', updateButtonState);
  });

  // Initial check in case any inputs are pre-selected on page load
  updateButtonState();
});
































































document.addEventListener('DOMContentLoaded', function() {
  console.log('--- Debugging Script for .confirmx-button Loaded ---');

  // Configuration constants (MUST match your cart submission and calculation scripts)
  const BAG_SIZE_GRAMS = 200;

  // LocalStorage Keys - Ensure these match your saving scripts!
  const localStorageAdjustedGramsKey = 'order_note_adjusted_grams';
  const localStorageFrequencyKey = 'order_note_delivery_frequency_weeks';
  const localStorageSelectedIngredientsKey = 'order_note_selected_ingredients'; // This KEY MUST MATCH your ingredient saving script

  // Map ingredient names to their specific variant IDs (for reference in logs)
  const ingredientVariantMap = {
    'pollo': '45902440005880',
    'carne': '45902463664376',
    'pernil': '45902463697144'
  };

  const confirmButton = document.querySelector('.confirmx-button');

  if (confirmButton) {
    confirmButton.addEventListener('click', function() {
      console.log('\n--- .confirmx-button Clicked: Simulating Order Calculation for Debugging ---');

      // --- 1. Retrieve & Calculate totalBagsForDisplay ---
      let currentGrams = parseInt(localStorage.getItem(localStorageAdjustedGramsKey));
      let deliveryWeeks = parseInt(localStorage.getItem(localStorageFrequencyKey));

      // Apply same fallbacks/defaults as the cart script
      currentGrams = (isNaN(currentGrams) || currentGrams <= 0) ? 100 : Math.max(50, currentGrams);
      deliveryWeeks = (isNaN(deliveryWeeks) || deliveryWeeks <= 0) ? 1 : deliveryWeeks;

      const gramsPerWeek = currentGrams * 7;
      const totalGramsForDeliveryPeriod = gramsPerWeek * deliveryWeeks;
      let totalBagsForDisplay = Math.ceil(totalGramsForDeliveryPeriod / BAG_SIZE_GRAMS);

      // Ensure at least 1 bag if calculations yield 0
      if (totalBagsForDisplay === 0) {
        totalBagsForDisplay = 1;
      }

      console.log(`DEBUG: Based on ${currentGrams}g/day and ${deliveryWeeks} weeks frequency.`);
      console.log(`DEBUG: Calculated **Overall Total Bags for Order**: ${totalBagsForDisplay}`);


      // --- 2. Get Selected Ingredients and Simulate Distribution ---
      let selectedIngredientsString = localStorage.getItem(localStorageSelectedIngredientsKey);
      let selectedIngredients = [];

      if (selectedIngredientsString) {
        // Parse and filter: Ensure ingredients are lowercase and recognized by our map
        selectedIngredients = selectedIngredientsString.split(',')
                                                    .map(item => item.trim().toLowerCase())
                                                    .filter(item => ingredientVariantMap.hasOwnProperty(item));
      }

      const numberOfSelectedIngredients = selectedIngredients.length;

      // If no valid ingredients are found after processing localStorage, log an error and stop.
      if (numberOfSelectedIngredients === 0) {
        console.warn('DEBUG: **No valid ingredients selected in localStorage (or key mismatch/empty value)**. No products would be ordered for specific flavors.');
        console.log('----------------------------------------------------');
        return; // Stop here if no ingredients would be ordered
      }

      let baseQuantityPerIngredient = Math.floor(totalBagsForDisplay / numberOfSelectedIngredients);
      let remainder = totalBagsForDisplay % numberOfSelectedIngredients;

      console.log(`DEBUG: Detected **Selected Ingredients**: ${selectedIngredients.join(', ')}`);
      console.log(`DEBUG: Number of Selected Ingredients: ${numberOfSelectedIngredients}`);
      console.log(`DEBUG: Base Bags per Ingredient: ${baseQuantityPerIngredient}, Remaining Bags to Distribute: ${remainder}`);

      let simulatedOrderItems = [];
      let totalSimulatedQuantity = 0;

      selectedIngredients.forEach((ingredient) => {
        const variantId = ingredientVariantMap[ingredient];
        let quantityForThisIngredient = baseQuantityPerIngredient;
        if (remainder > 0) {
          quantityForThisIngredient++;
          remainder--;
        }

        if (quantityForThisIngredient > 0) {
          simulatedOrderItems.push({
            ingredient: ingredient.charAt(0).toUpperCase() + ingredient.slice(1), // Capitalize for display
            variantId: variantId,
            quantity: quantityForThisIngredient
          });
          totalSimulatedQuantity += quantityForThisIngredient;
        }
      });

      console.log('\n--- DEBUG: **Simulated Order Breakdown by Ingredient** ---');
      if (simulatedOrderItems.length > 0) {
          simulatedOrderItems.forEach(item => {
            console.log(`  - ${item.ingredient}: ${item.quantity} bags (Variant ID: ${item.variantId})`);
          });
      } else {
          console.warn('DEBUG: No individual ingredient products were prepared, despite selected ingredients found. (This indicates an unexpected calculation result where quantities became zero)');
      }

      console.log(`DEBUG: **Total Simulated Bags to Order**: ${totalSimulatedQuantity} (Should match Calculated Overall Total: ${totalBagsForDisplay})`);
      console.log('----------------------------------------------------');

    });
  } else {
    console.warn('DEBUG: Button with class ".confirmx-button" not found. Debugging output on click will not work.');
  }
});






document.addEventListener('DOMContentLoaded', function() {
  // Get references to your radio buttons
  const cardPaymentRadio = document.getElementById('card-paymentx');
  const manualPaymentRadio = document.getElementById('manual-paymentx');

  // --- NEW: Explicitly uncheck the radio buttons on page load ---
  cardPaymentRadio.checked = false;
  manualPaymentRadio.checked = false;
  // --- END NEW ---

  // Function to save the selected value to local storage
  function savePaymentChoice() {
    if (cardPaymentRadio.checked) {
      localStorage.setItem('selectedPaymentOption', cardPaymentRadio.value);
    } else if (manualPaymentRadio.checked) {
      localStorage.setItem('selectedPaymentOption', manualPaymentRadio.value);
    } else {
      // Optional: If neither is checked (e.g., if a user somehow deselects both,
      // which is not standard for radio buttons without custom JS),
      // you might want to remove the stored value.
      // localStorage.removeItem('selectedPaymentOption');
    }
  }

  // Add event listeners to the radio buttons
  // When a user makes a selection, it gets saved to local storage.
  cardPaymentRadio.addEventListener('change', savePaymentChoice);
  manualPaymentRadio.addEventListener('change', savePaymentChoice);

  // The code that used to read from localStorage and check the buttons is intentionally omitted.
  // We only save, we don't load the 'checked' state.
});













document.addEventListener('DOMContentLoaded', () => {

    // --- Configuration constants (MOVED HERE to be in scope for click handler) ---
    const BAG_SIZE_GRAMS = 200;

    // Define the mapping between ingredient names and their Shopify Variant IDs
    const ingredientVariantMap = {
        'pollo': '45902440005880',
        'carne': '45902463664376',
        'pernil': '45902463697144'
    };

    // Define the mapping for SELLING PLAN IDs for AUTO (subscription) purchase based on frequency name
    const sellingPlanIdMap = {
        '1 Semana': '4672291064',
        '2 Semanas': '4715020536',
        '3 Semanas': '4715053304',
        '4 Semanas': '4715086072',
        '5 Semanas': '4719116536',
        '6 Semanas': '4719149304',
        '7 Semanas': '4719182072',
        '8 Semanas': '4719214840',
        '9 Semanas': '4719247608',
        '10 Semanas': '4719280376',
        '11 Semanas': '4719313144',
        '12 Semanas': '4719345912',
        '13 Semanas': '5010751736'
    };

    // Keys for localStorage data (MOVED HERE too)
    const localStorageAdjustedGramsKey = 'order_note_adjusted_grams';
    const localStorageFrequencyKey = 'order_note_delivery_frequency_weeks';
    const localStorageSelectedIngredientsKey = 'order_note_selected_ingredients';
    const localStoragePaymentOptionKey = 'selectedPaymentOption';
    const localStorageSelectedFrequencyNameKey = 'order_note_delivery_frequency_display';
    const localStorageAddedProductsSummaryKey = 'added_products_summary';

    // Select the "Add to Cart" button
    const cartButtonX = document.querySelector('.cart-buttonx');

    if (cartButtonX) {
        cartButtonX.addEventListener('click', function() {
            $(".modal").show();
            let items = [];
            const addedProductsSummary = [];

            // --- Retrieve payment option and frequency name ---
            const selectedPaymentOption = localStorage.getItem(localStoragePaymentOptionKey);
            const storedFrequencyName = localStorage.getItem(localStorageSelectedFrequencyNameKey);

            // --- Calculate totalBagsForDisplay ---
            console.log("\n--- 'cart-buttonx' Clicked! Calculating Total Bags and Gathering Ingredients ---");

            let currentGrams = parseInt(localStorage.getItem(localStorageAdjustedGramsKey));
            let deliveryWeeks = parseInt(localStorage.getItem(localStorageFrequencyKey));

            currentGrams = (isNaN(currentGrams) || currentGrams <= 0) ? 100 : Math.max(50, currentGrams);
            deliveryWeeks = (isNaN(deliveryWeeks) || deliveryWeeks <= 0) ? 1 : deliveryWeeks;

            const gramsPerWeek = currentGrams * 7;
            const totalGramsForDeliveryPeriod = gramsPerWeek * deliveryWeeks;
            let totalBagsForDisplay = Math.ceil(totalGramsForDeliveryPeriod / BAG_SIZE_GRAMS);

            if (totalBagsForDisplay === 0) {
                totalBagsForDisplay = 1;
            }
            console.log(`Calculated Total Bags for Display: ${totalBagsForDisplay}`);

            // --- Determine the frequency display string for item properties and order note ---
            let frequencyPropertyKey = 'Frecuencia';
            let frequencyPropertyValue = storedFrequencyName || 'N/A';

            if (selectedPaymentOption === 'manual') {
                frequencyPropertyKey = 'Frecuencia única';
            } else if (selectedPaymentOption !== 'auto' && selectedPaymentOption !== 'manual') {
                console.warn(`Unknown payment option '${selectedPaymentOption}'. Defaulting to 'Frecuencia' property.`);
            }

            // --- Get Selected Ingredients and Distribute Quantity ---
            let selectedIngredientsString = localStorage.getItem(localStorageSelectedIngredientsKey);
            let selectedIngredients = [];

            if (selectedIngredientsString) {
                selectedIngredients = selectedIngredientsString.split(',')
                    .map(item => item.trim().toLowerCase())
                    .filter(item => ingredientVariantMap.hasOwnProperty(item));
            }

            const numberOfSelectedIngredients = selectedIngredients.length;
            if (numberOfSelectedIngredients === 0) {
                $(".modal").hide();
                alert("No products can be added as no ingredients were selected or recognized. Please choose your ingredients.");
                console.error("Cart Button Click: No valid selected ingredients found to add products for. Stopping.");
                return;
            }

            let baseQuantityPerIngredient = Math.floor(totalBagsForDisplay / numberOfSelectedIngredients);
            let remainder = totalBagsForDisplay % numberOfSelectedIngredients;

            console.log(`Selected Ingredients: ${selectedIngredients.join(', ')}`);
            console.log(`Base Quantity per Ingredient: ${baseQuantityPerIngredient}, Remainder: ${remainder}`);

            selectedIngredients.forEach((ingredient, index) => {
                const variantId = ingredientVariantMap[ingredient];
                if (variantId) {
                    let quantityForThisIngredient = baseQuantityPerIngredient;
                    if (remainder > 0) {
                        quantityForThisIngredient++;
                        remainder--;
                    }

                    if (quantityForThisIngredient > 0) {
                        let sellingPlanIdToAdd = null;
                        let productUrl = `https://www.boneappetit.food/products/testing`;

                        if (selectedPaymentOption === 'auto') {
                            sellingPlanIdToAdd = sellingPlanIdMap[storedFrequencyName];
                            if (sellingPlanIdToAdd) {
                                productUrl += `?variant=${variantId}&selling_plan=${sellingPlanIdToAdd}`;
                            } else {
                                console.warn(`Selling Plan ID not found for frequency '${storedFrequencyName}'. Item will be added without a selling plan.`);
                                productUrl += `?variant=${variantId}`;
                            }
                        } else {
                            productUrl += `?variant=${variantId}`;
                        }

                        let itemProperties = {};
                        itemProperties[frequencyPropertyKey] = frequencyPropertyValue;
                        itemProperties['Resumen'] = `${quantityForThisIngredient} paquetes de ${BAG_SIZE_GRAMS}gr de ${ingredient}`;

                        const itemToAdd = {
                            id: variantId,
                            quantity: quantityForThisIngredient,
                            properties: itemProperties
                        };

                        if (selectedPaymentOption === 'auto' && sellingPlanIdToAdd) {
                            itemToAdd.selling_plan = sellingPlanIdToAdd;
                        }

                        items.push(itemToAdd);
                        console.log(`Added ${ingredient} (Variant: ${variantId}, Quantity: ${quantityForThisIngredient}, Selling Plan: ${sellingPlanIdToAdd || 'None'})`);

                        addedProductsSummary.push({
                            name: ingredient,
                            quantity: quantityForThisIngredient,
                            url: productUrl
                        });

                    } else {
                        console.warn(`Skipping ${ingredient} as calculated quantity is 0 for this distribution.`);
                    }
                } else {
                    console.error(`Internal error: No variant ID found for a selected ingredient: ${ingredient}`);
                }
            });

            // --- Generate Order Note ---
            const noteMappings = {
                'order_note_cat_name': "Cat's Name",
                'order_note_dog_gender': "Cat's Gender",
                'order_note_dog_desexed': "Cat Neutered",
                'order_note_cat_age_stage': "Cat Category",
                'order_note_main_breed': "Cat Breed",
                'order_note_current_food': "Cat Food Type",
                'order_note_eating_habit': "Cat Eating Type",
                'order_note_cat_body': "Cat Shape",
                'order_note_cat_activity': "Cat Activity",
                'order_note_weight': "Cat Weight",
                'healthIssueDescription': "Health Problem",
                'order_note_allergies': "Cat Allergies",
                'order_note_selected_ingredients': "Selected Ingredients",
                'order_note_adjusted_grams': "Grams Per Day",
                'order_note_price_per_day_cat': "Price Per Week"
            };

            let orderNoteParts = [];



          

           
// Loop through the noteMappings first to add all other details
for (const key in noteMappings) {
    if (Object.hasOwnProperty.call(noteMappings, key)) {
        const label = noteMappings[key];
        // Ensure these keys are not added here if they were mistakenly in noteMappings
        // (though they generally shouldn't be, as we're adding them explicitly later)
        if (key === localStorageFrequencyKey || key === localStorageSelectedFrequencyNameKey || key === localStoragePaymentOptionKey) {
             continue; // Skip these if they somehow exist in noteMappings
        }
        const value = localStorage.getItem(key);
        if (value && value.trim() !== '') {
            orderNoteParts.push(`${label}: ${value}`);
        }
    }
}



// >>>>>>>>>>> INSERT THE BLOCK HERE <<<<<<<<<<<
// --- Add Extra Pet Info from localStorage ---
const extraPetFields = [
  { key: 'Extra Pet Type', label: 'Extra Pet Type' },
  { key: 'Extra Pet Pet Name', label: 'Extra Pet Name' },
  { key: 'Extra Pet Pet Breed', label: 'Extra Pet Breed' },
  { key: 'Extra Pet Pet Neutered', label: 'Extra Pet Neutered' },
  { key: 'Extra Pet Pet Stage', label: 'Extra Pet Stage' },
  { key: 'Extra Pet Pet Weight', label: 'Extra Pet Weight' },
  { key: 'Extra Pet Pet Activity', label: 'Extra Pet Activity' },
  { key: 'Extra Pet Pet Allergies', label: 'Extra Pet Allergies' }
];

extraPetFields.forEach(({ key, label }) => {
  const value = localStorage.getItem(key);
  if (value && value.trim() !== '') {
    orderNoteParts.push(`${label}: ${value.trim()}`);
  }
});
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<



// Now, push Payment Option and Frequency at the end
orderNoteParts.push(`Payment Option: ${selectedPaymentOption || 'N/A'}`);
orderNoteParts.push(`${frequencyPropertyKey}: ${frequencyPropertyValue}`);


const finalOrderNote = orderNoteParts.join('\n');
console.log("Generated Order Note:\n", finalOrderNote);




          

            // --- Final Cart Submission ---
            console.log("Final items array to add:", items);
            console.log("Products Summary for localStorage:", addedProductsSummary);

            if (items.length === 0) {
                $(".modal").hide();
                alert("No products were prepared for the cart. This indicates an issue with ingredient selection or calculation.");
                console.error("Cart Button Click: Items array is empty before submission. Stopping.");
                return;
            }

            // --- Save the product summary to localStorage ---
            localStorage.setItem(localStorageAddedProductsSummaryKey, JSON.stringify(addedProductsSummary));

            let data = {
                items: items,
                note: finalOrderNote
            };

            let checkoutUrl = $("form#cart").attr('action');
            if (checkoutUrl) {
                checkoutUrl = checkoutUrl.replace('/cart/', '/checkout/');
            } else {
                checkoutUrl = '/checkout/';
            }
            console.log("Cart Button Click: Checkout URL:", checkoutUrl);


            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function(response) {
                    console.log('Products successfully added to cart:', response);
                    window.location.href = checkoutUrl + 'discount=bienvenido,SHIPFREE';
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    $(".modal").hide();
                    alert('Failed to add products to cart. Please try again.');
                    console.error('Failed to add products to cart:', textStatus, errorThrown);
                    console.error('Response:', jqXHR.responseText);
                }
            });
        });
    } else {
        console.error("CRITICAL ERROR: Element with class 'cart-buttonx' not found. Add to cart functionality disabled.");
    }
});








(function () {
    'use strict';

    let isInitialized = false;
    let observerInstance = null;

    const ACTIVE_BUTTON_KEY = 'activeButtonId';
    const STORED_FREQUENCY_KEY = 'Collected New Frequency';

    // Now using CLASS selectors
    const CAT_SPAN_SELECTOR = '.cat-frequency-option';
    const DOG_SPAN_SELECTOR = '.frequency-option';

    const DEFAULT_GATO = '1 Semana';
    const DEFAULT_PERRO = '2 Semanas';

    // Get active button from localStorage
    function getActiveButtonId() {
        return localStorage.getItem(ACTIVE_BUTTON_KEY);
    }

    // Get text from first element matching selector
    function getSpanValue(selector) {
        const el = document.querySelector(selector);
        return el ? el.textContent.trim() : null;
    }

    // Determine value based on active button + defaults
    function determineFrequencyValue(activeButton) {
        if (activeButton === 'gatoButton0001') {
            return getSpanValue(CAT_SPAN_SELECTOR) || DEFAULT_GATO;
        } else if (activeButton === 'perroButton0001') {
            return getSpanValue(DOG_SPAN_SELECTOR) || DEFAULT_PERRO;
        }
        return null;
    }

    // Save and log
    function updateStoredFrequency(value, source = 'initial') {
        if (value === null) return;
        localStorage.setItem(STORED_FREQUENCY_KEY, value);
        console.log(
            `%c📥 Collected New Frequency (${source}) → "${value}"`,
            'color: #2E8B57; font-weight: bold;'
        );
    }

    // Main check logic
    function checkAndUpdateFrequency(source = 'observer') {
        const activeButton = getActiveButtonId();
        if (!['gatoButton0001', 'perroButton0001'].includes(activeButton)) {
            console.warn(`⚠️ Unsupported activeButtonId: "${activeButton}"`);
            return;
        }

        const value = determineFrequencyValue(activeButton);
        updateStoredFrequency(value, source);
    }

    // Set up MutationObserver on matching elements
    function initMutationObserver() {
        // Clean up previous observer if any
        if (observerInstance) {
            observerInstance.disconnect();
        }

        observerInstance = new MutationObserver(() => {
            clearTimeout(observerInstance.debounceTimer);
            observerInstance.debounceTimer = setTimeout(() => {
                checkAndUpdateFrequency('observer');
            }, 100);
        });

        const config = { childList: true, subtree: true, characterData: true };

        // Observe all current matching elements
        const catEls = document.querySelectorAll(CAT_SPAN_SELECTOR);
        const dogEls = document.querySelectorAll(DOG_SPAN_SELECTOR);

        catEls.forEach(el => observerInstance.observe(el, config));
        dogEls.forEach(el => observerInstance.observe(el, config));

        console.log(
            `%c👁️ MutationObserver active on: ${catEls.length} cat span(s), ${dogEls.length} dog span(s)`,
            'color: #4682B4; font-weight: bold;'
        );

        // Optional: Warn if no elements found
        if (catEls.length === 0 && dogEls.length === 0) {
            console.warn('⚠️ No .cat-frequency-option or .frequency-option elements found!');
        }
    }

    // Full initialization
    function initializeScript() {
        if (isInitialized) return;
        isInitialized = true;

        console.log(
            '%c🐾 Activated by "dog-weight next" click – starting frequency collector',
            'background: #f0f8ff; color: #2F4F4F; padding: 2px 5px; border-radius: 3px;'
        );

        // Initial read
        checkAndUpdateFrequency('initial');

        // Start observing
        initMutationObserver();
    }

    // Activate on click of .dog-weight.next
    document.addEventListener('click', function (e) {
        if (e.target.closest('.dog-weight.next')) {
            initializeScript();
        }
    });

})();